<template>
    <div class="sabo-help-box">
        <span v-tooltip.click="{ html: messageRef, class: 'tooltip-custom tooltip-other-custom' }">
            <div class="help-box">
                <button type="button" title="" class="btn btn--round help-box-button">
                    <span> i </span>
                </button>
            </div>
        </span>
        <div :id="messageRef">
            <div class="">
                <h3 class="popover-title">
                    {{ title }}
                    <button type="button" class="btn btn--none help-box-close">
                        <span class="spinner spinner--black glyphicon glyphicon-remove"></span>
                    </button>
                </h3>
                <div class="popover-content" v-html="message"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {type: String},
            messageRef: {type: String, required: true},
            message: {type: String}
        }
    }
</script>

<style lang="scss">
    @import "./assets/stylesheets/base/colors";
    @import "./assets/stylesheets/modules/mixins";

    .help-box {
        display: inline-block;
        margin-left: 10px;
        overflow-x: auto !important;

        .help-box-button {
            display: inline-block;
            @include font-size(12);
            font-weight: bold;
            text-transform: lowercase;
        }

        .popover {
            border: 1px solid $help-box-border;
            border-radius: 2px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.21);
            background: $help-box-background;

            .popover-title {
                @include font-size(18);
                color: $help-box-title;
                background: none;
                border: none;
            }

            .popover-content {
                overflow-x: unset;
            }

            .arrow {
                visibility: hidden;
            }
        }

        .help-box-close {
            @include font-size(14);
            float: right;
            padding-left: 5px;
            margin-left: 15px;
        }
    }

    .control-label {
        .help-box {
            vertical-align: bottom;
        }
    }

    .help-box-align--top { // useful when using help box next to e.g. radios
        .help-box {
            vertical-align: top;
        }
    }
</style>



// WEBPACK FOOTER //
// assets/vue/houseModel/components/saboHelpBox.vue